/*
 * @Author: Hyman Choi
 * @Date: 2021-01-22 15:50:27
 * @LastEditTime: 2022-01-19 11:29:10
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Siui.Cloud.Medical.Web\src\api\videoCourse.js
 */
import request from "@/utils/request";
import config from "@/utils/config";

import {
	getForumCategoryList
} from "@/api/ultrasonic"
import {handleUrlEncode} from "@/utils/urlutil";

/**
 * 获取所有视频
 *
 * @param {*} params
 */
export function getAllVideoList(params) {
	let url = config.API_ADMIN + "/Api/V1/AdminVideos/AllVideoList?"
	url = handleUrlEncode(url,params)
	return request({
		url: url,
		method: "get",
	});
}

/**
 * 添加单个视频
 *
 * @param {*} data
 */
export function addVideo(data) {
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminVideos/Add",
		method: "post",
		data,
	});
}

/**
 * 设置单个视频状态
 *
 * @param {*} params
 */
export function setVideo(params) {
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminVideos/Video/Set",
		method: "post",
		params,
	});
}

/**
 * 删除/恢复单个视频
 *
 * @param {*} params
 */
export function deleteOrBackVideo(params) {
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminVideos/DeleteOrBack",
		method: "delete",
		params,
	});
}

/**
 * 获取所有视频标签
 *
 * @param {*} params
 */
export function getVideoTabList(params) {
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminVideos/VideoTabList",
		method: "get",
		params,
	});
}

/**
 * 获取所有视频标签
 *
 * @param {*} params
 */
export function setVideoTab(params) {
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminVideos/VideoTab/SystemDefault",
		method: "post",
		params,
	});
}

/**
 * 添加单个视频标签
 *
 * @param {*} data
 */
export function addVideoTab(data) {
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminVideos/VideoTab/Add",
		method: "post",
		data,
	});
}

/**
 * 更新单个视频标签
 *
 * @param {*} data
 */
export function updateVideoTab(data) {
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminVideos/VideoTab/Update",
		method: "post",
		data,
	});
}

/**
 * 删除单个视频标签
 *
 * @param {*} params
 */
export function deleteVideoTab(params) {
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminVideos/VideoTab/Delete",
		method: "delete",
		params,
	});
}

/**
 * fixme
 * 获取视频课程所有类型
 */
export function getCategoryList(){
	return getForumCategoryList()
}
